module.exports = __webpack_public_path__ + "static/media/search.ce561731.svg";